import lang from "translations";

const columnByKey = {
  name: { key: "name", text: lang.name, align: "left" },
  gender: { key: "gender", text: lang.gender, align: "left" },
  email: { key: "email", text: lang.email, align: "left" },
  mobileNumber: { key: "mobileNumber", text: lang.mobileNumber, align: "left" },
  birthdate: { key: "birthdate", text: lang.birthdate, align: "left" },
  nationality: { key: "nationality", text: lang.nationality, align: "left" },
  identificationType: {
    key: "identificationType",
    text: lang.identificationType,
    align: "left",
  },
  idNumber: { key: "idNumber", text: lang.idNumber, align: "left" },
  idScan: { key: "idScan", text: lang.idScan, align: "left" },
  medicalCondition: { key: "medicalCondition", text: lang.medicalCondition, align: "left" },
  foodAllergies: { key: "foodAllergies", text: lang.foodAllergies, align: "left" },
  specialNotes: { key: "specialNotes", text: lang.specialNotes, align: "left" },
  freeCredit: { key: "freeCredit", text: lang.freeCredit, align: "left" },
  guestProfile: { key: "guestProfile", text: lang.guestProfile, align: "left" },
  ticketNo: { key: "ticketNo", text: lang.ticketNo, align: "left" },
  preloadedCredit: { key: "preloadedCredit", text: lang.preloadedCredit, align: "left" },
  staffNote: { key: "staffNote", text: lang.staffNote, align: "left" },
  checkinDate: { key: "checkinDate", text: lang.checkInDate, align: "right" },
};

// The order every non-EatApp venue keeps, unchanged from before the manifest columns landed.
const legacyOrder = [
  "name",
  "email",
  "mobileNumber",
  "gender",
  "birthdate",
  "nationality",
  "guestProfile",
  "ticketNo",
  "preloadedCredit",
  "staffNote",
  "checkinDate",
];

// An EatApp reservation adds the pre-checkin manifest fields and moves the title up behind the name.
// Ticket No. and Preloaded Credit are left out: EatApp carries neither, so both columns were
// always empty. Preloaded Credit also renders its raw value, which would sit oddly next to the
// money-formatted Free Credit.
const eatappOrder = [
  "name",
  "gender",
  "email",
  "mobileNumber",
  "birthdate",
  "nationality",
  "identificationType",
  "idNumber",
  "idScan",
  "medicalCondition",
  "foodAllergies",
  "specialNotes",
  "freeCredit",
  "guestProfile",
  "staffNote",
  "checkinDate",
];

const legacyColumns = legacyOrder.map((key) => columnByKey[key]);
const eatappColumns = eatappOrder.map((key) => columnByKey[key]);

const getColumns = (isEatapp) => (isEatapp ? eatappColumns : legacyColumns);

export default getColumns;
